module.exports = __webpack_public_path__ + "static/silver_dragon_breath-7fbdf44c923f51a80e7c54d63d30b44d.jpg";